import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export const HomeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 288 288">
    <svg
      id="SvgjsSvg1001"
      width="288"
      height="288"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
    >
      <defs id="SvgjsDefs1002"></defs>
      <g
        id="SvgjsG1008"
        transform="matrix(0.9167,0,0,0.9167,11.995200000000011,11.995200000000011)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="288"
          height="288"
          viewBox="0 0 48 48"
        >
          <path
            d="M20 40v-12h8v12h10v-16h6l-20-18-20 18h6v16z"
            // fill="#000"
            className="color000 svgShape"
          ></path>
          <path fill="none" d="M0 0h48v48h-48z"></path>
        </svg>
      </g>
    </svg>
  </SvgIcon>
);
